function convertDate(date) {
  date = date.normalize("NFD").replace(/\p{Diacritic}/gu, "")
  const months = {
    janvier: "january",
    fevrier: "february",
    mars: "march",
    avril: "april",
    mai: "may",
    juin: "june",
    juillet: "july",
    aout: "august",
    septembre: "september",
    octobre: "october",
    novembre: "november",
    decembre: "december",
  }
  date = date + ""
  date = date.split(" ")
  return date[0] + " " + months[date[1]] + " " + date[2]
}
const regExp = /[a-zA-Z]/
export const getPublishedData = (data) => {
  const date = new Date().toLocaleDateString("fr-CA")
  const finalData = data.filter(({ node }) => {
    if (node.field_affichage_planifie) {
      if (node.field_date_de_publication) {
        let datePublication = node.field_date_de_publication.split("/")
        datePublication =
          datePublication[2] +
          "-" +
          datePublication[1] +
          "-" +
          datePublication[0]
        if (datePublication > date) return false
      }
      if (node.field_date_de_depublication) {
        let dateDepublication = node.field_date_de_depublication.split("/")
        dateDepublication =
          dateDepublication[2] +
          "-" +
          dateDepublication[1] +
          "-" +
          dateDepublication[0]
        if (dateDepublication < date) return false
      }
      return true
    }
    return true
  })
  if (finalData.length > 0) {
    if (finalData[0].node.relationships.field_image_event === undefined) {
      return finalData.sort((firstNode, secondNode) => {
        let dateA =
          firstNode.node.field_date_de_publication ?? firstNode.node.created
        let dateB =
          secondNode.node.field_date_de_publication ?? secondNode.node.created

        if (!dateA || !dateB) return 0

        if (
          regExp.test(dateA.normalize("NFD").replace(/\p{Diacritic}/gu, ""))
        ) {
          dateA = convertDate(dateA)
        } else {
          dateA = dateA.split("/")
          dateA = dateA[2] + "-" + dateA[1] + "-" + dateA[0]
        }

        if (
          regExp.test(dateB.normalize("NFD").replace(/\p{Diacritic}/gu, ""))
        ) {
          dateB = convertDate(dateB)
        } else {
          dateB = dateB.split("/")
          dateB = dateB[2] + "-" + dateB[1] + "-" + dateB[0]
        }
        return new Date(dateB) - new Date(dateA)
      })
    }
  }
  return finalData
}
